// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.invoiceHistory {
  grid-template-columns: repeat(6, auto);
}
.grid.invoiceHistoryExpanded {
  grid-template-columns: repeat(7, auto);
}
i {
  padding-right: 10px;
}
.green-icon {
  color: #54a54e !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/payments/invoice-history-list/invoice-history-list.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;AADF;AAGA;EACE,sCAAA;AADF;AAIA;EACE,sCAAA;AAFF;AAKA;EACE,mBAAA;AAHF;AAKA;EACE,yBAAA;AAHF","sourcesContent":["@import (reference) url(\"../../../../styles.less\");\n\nh1 {\n  margin: 0;\n}\n.grid.invoiceHistory {\n  grid-template-columns: repeat(6, auto);\n}\n\n.grid.invoiceHistoryExpanded {\n  grid-template-columns: repeat(7, auto);\n}\n\ni {\n  padding-right: 10px;\n}\n.green-icon {\n  color: @green !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
